import { render, staticRenderFns } from "./ExpenseAddModal.vue?vue&type=template&id=072b238d"
import script from "./ExpenseAddModal.vue?vue&type=script&lang=js"
export * from "./ExpenseAddModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports